import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.function.name.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { observable, runInAction, computed, makeObservable, toJS } from "mobx";
import { PlatformType } from "@dp/common";
import moment from "moment";
import i18next from "i18next";
var AnalyticsModel = (_class = /*#__PURE__*/function () {
  function AnalyticsModel(platformUtil) {
    _classCallCheck(this, AnalyticsModel);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor, this);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor2, this);

    _initializerDefineProperty(this, "_cart", _descriptor3, this);

    _initializerDefineProperty(this, "_menuItemDetail", _descriptor4, this);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "_returnWindowDigData", _descriptor5, this);

    _initializerDefineProperty(this, "_waitListData", _descriptor6, this);

    _initializerDefineProperty(this, "_pageAnalyticsDetails", _descriptor7, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor8, this);

    _initializerDefineProperty(this, "_curbsideTransactionDetails", _descriptor9, this);

    _initializerDefineProperty(this, "_curbsideDetails", _descriptor10, this);

    _initializerDefineProperty(this, "_changeErrorPageNameWithoutRD", _descriptor11, this);

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(AnalyticsModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this = this;

      runInAction(function () {
        _this._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(_restaurantDetail) {
      var _this2 = this;

      if (!_restaurantDetail) {
        return;
      }

      runInAction(function () {
        var _restaurantDetail$add;

        _this2._restaurantDetail = {
          locationId: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantInfo,
          restaurantNum: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantNum,
          locationName: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantName,
          locationState: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.address.state,
          locationZip: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$add = _restaurantDetail.address) === null || _restaurantDetail$add === void 0 ? void 0 : _restaurantDetail$add.zipCode
        };
      });
    } // TODO: use this once migrated to cloud

  }, {
    key: "setRestaurantDetailDataCloud",
    value: function setRestaurantDetailDataCloud(_restaurantDetail) {
      var _this3 = this;

      if (!_restaurantDetail) {
        return;
      }

      runInAction(function () {
        var _restaurantDetail$res, _restaurantDetail$con, _restaurantDetail$con2, _restaurantDetail$con3, _restaurantDetail$con4, _restaurantDetail$con5;

        _this3._restaurantDetail = {
          locationId: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.atgRestaurantId,
          restaurantNum: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$res = _restaurantDetail.restaurantNumber) === null || _restaurantDetail$res === void 0 ? void 0 : _restaurantDetail$res.toString(),
          locationName: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantName,
          locationState: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con = _restaurantDetail.contactDetail) === null || _restaurantDetail$con === void 0 ? void 0 : (_restaurantDetail$con2 = _restaurantDetail$con.address) === null || _restaurantDetail$con2 === void 0 ? void 0 : _restaurantDetail$con2.stateName,
          locationZip: _restaurantDetail === null || _restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con3 = _restaurantDetail.contactDetail) === null || _restaurantDetail$con3 === void 0 ? void 0 : (_restaurantDetail$con4 = _restaurantDetail$con3.address) === null || _restaurantDetail$con4 === void 0 ? void 0 : (_restaurantDetail$con5 = _restaurantDetail$con4.zipCode) === null || _restaurantDetail$con5 === void 0 ? void 0 : _restaurantDetail$con5.toString()
        };
      });
    }
  }, {
    key: "setCartData",
    value: function setCartData(_cart) {
      var _this4 = this;

      runInAction(function () {
        _this4._cart = _cart;
      });
    }
  }, {
    key: "setMenuItemDetailData",
    value: function setMenuItemDetailData(item) {
      var _this5 = this;

      runInAction(function () {
        _this5._menuItemDetail = item;
      });
    }
  }, {
    key: "setReturnWindowDigData",
    value: function setReturnWindowDigData(returnWindowDigData) {
      this._returnWindowDigData = returnWindowDigData;
    }
  }, {
    key: "setChangeErrorPageNameWithoutRD",
    value: function setChangeErrorPageNameWithoutRD(_val) {
      var _this6 = this;

      runInAction(function () {
        _this6._changeErrorPageNameWithoutRD = _val;
      });
    }
  }, {
    key: "dispatchLocationSearchModalEvent",

    /************************************************* MENU LIST EVENTS *****************************************/
    value: function dispatchLocationSearchModalEvent(coords) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationSearchModal", {
        coordinates: (coords === null || coords === void 0 ? void 0 : coords.latitude) + ", " + (coords === null || coords === void 0 ? void 0 : coords.longitude)
      });
    }
  }, {
    key: "dispatchGetRecommendationsEvent",
    value: function dispatchGetRecommendationsEvent(restaurantId, restaurantNum, recommendations, type) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "GetRecommendations", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        numberOfRecommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.length,
        recommended: recommendations,
        type: type
      });
    }
  }, {
    key: "dispatchLocationChangedEvent",
    value: function dispatchLocationChangedEvent(restaurantId, restaurantNum, prevRestaurantId, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationChange", {
        location: {
          newRestaurantId: restaurantId,
          prevRestaurantId: prevRestaurantId,
          restNum: restaurantNum,
          changed: true
        },
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSmartRecommendationsForCheckoutEvent",
    value: function dispatchSmartRecommendationsForCheckoutEvent(restaurantId, restaurantNum, recommendations) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SmartRecommendationsForCheckout", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        numberOfRecommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.length,
        recommended: recommendations,
        type: "shoppingcart"
      });
    }
  }, {
    key: "dispatchFromSmartRecommendationEvent",
    value: function dispatchFromSmartRecommendationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "AddedFromSmartRecommendedModal", {
        itemAdded: true
      });
    }
  }, {
    key: "dispatchUnavailableItemsEvent",
    value: function dispatchUnavailableItemsEvent(restaurantId, restaurantNum, _86Items) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "UnavailableItems", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        unavailableItems: _86Items
      });
    }
  }, {
    key: "dispatchSetLocationDataEvent",
    value: function dispatchSetLocationDataEvent(latitude, longitude) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetLocationData", {
        latitude: latitude,
        longitude: longitude
      });
    }
  }, {
    key: "dispatchSetOrderHistoryDataEvent",
    value: function dispatchSetOrderHistoryDataEvent(orderHistory) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderHistoryData", {
        orderHistory: orderHistory
      });
    }
  }, {
    key: "dispatchSearchMyLocationEvent",
    value: function dispatchSearchMyLocationEvent(coordinates, numberOfResults, restaurantIds) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SearchMyLocation", {
        coordinates: coordinates[0] + ", " + coordinates[1],
        numberOfResults: numberOfResults,
        restaurantIds: restaurantIds
      });
    }
  }, {
    key: "dispatchFetchTimesEvent",
    value: function dispatchFetchTimesEvent(resturantId, restaurantNum, selectedCalendarDate, orderType, capacityCheckEnabled, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "FetchTimes", {
        location: {
          restaurantId: resturantId,
          restNum: restaurantNum
        },
        selectedCalendarDate: selectedCalendarDate,
        orderType: orderType,
        capacityCheckEnabled: capacityCheckEnabled,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSetOrderPickupTimeEvent",
    value: function dispatchSetOrderPickupTimeEvent(date, time, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderPickupTime", {
        date: date,
        time: time,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchSetOrderPickupTimeAndLocationEvent",
    value: function dispatchSetOrderPickupTimeAndLocationEvent(restaurantId, restaurantNum, date, time, isAsapSelected, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SetOrderPickupTimeAndLocation", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        date: date,
        time: time,
        asap: isAsapSelected
      }));
    }
  }, {
    key: "dispatchSaveToFavoritesEvent",
    value: function dispatchSaveToFavoritesEvent(giftListId, giftListItemId, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "SaveToFavorites", {
        giftListId: giftListId,
        giftListItemId: giftListItemId,
        productId: productId
      });
    }
  }, {
    key: "dispatchRemoveFromFavoritesEvent",
    value: function dispatchRemoveFromFavoritesEvent(giftListId, giftListItemId, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "RemoveFromFavorites", {
        giftListId: giftListId,
        giftListItemId: giftListItemId,
        productId: productId
      });
    }
  }, {
    key: "dispatchLoadMenuDetailEvent",
    value: function dispatchLoadMenuDetailEvent(restaurantId, restaurantNum, menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, basePrice, productId, productName, productDetails, recommended, reorder, duplicate, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LoadMenuDetail", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          price: {
            basePrice: basePrice
          },
          productInfo: {
            productId: productId,
            productName: productName,
            productDetails: productDetails
          },
          recommended: recommended,
          reorder: reorder,
          duplicate: duplicate
        }]
      }));
    }
  }, {
    key: "dispatchLocationConfirmChangeEvent",
    value: function dispatchLocationConfirmChangeEvent(restaurantId, restaurantNum, locationChanged, pickupDate, pickupTime, dateTimeChanged, orderType, orderTypeChanged) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "LocationConfirmChange", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum,
          locationChanged: locationChanged
        },
        dateTime: {
          pickupDate: pickupDate,
          pickupTime: pickupTime,
          dateTimeChanged: dateTimeChanged
        },
        orderType: orderType,
        orderTypeChanged: orderTypeChanged
      });
    }
  }, {
    key: "dispatchTimeConfirmChangeEvent",
    value: function dispatchTimeConfirmChangeEvent(date, time, isAsapSelected) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "TimeConfirmChange", {
        date: date,
        time: time,
        asap: isAsapSelected
      });
    }
  }, {
    key: "dispatchOrderErrorEvent",
    value: function dispatchOrderErrorEvent(faultCode, faultDescription) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "OrderError", {
        faultCode: faultCode,
        faultDescription: faultDescription
      });
    }
  }, {
    key: "dispatchProductDetailsModalEvent",
    value: function dispatchProductDetailsModalEvent(type, productId, productSku, productName, recommended) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ProductDetailsModal", {
        menuType: type,
        productInfo: {
          productId: productId,
          productSku: productSku,
          productName: productName,
          recommended: recommended
        }
      });
    }
  }, {
    key: "dispatchUpdateCartEvent",
    value: function dispatchUpdateCartEvent(productId, sku, quantity) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "UpdateCart", {
        productId: productId,
        sku: sku,
        quantity: quantity
      });
    }
  }, {
    key: "dispatchDeleteCartItemEvent",
    value: function dispatchDeleteCartItemEvent(restaurantId, restaurantNum, basePrice, productId, productSku, productName, breadsticks, totalBreadCount) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DeleteCartItem", {
        location: {
          restaurantId: restaurantId,
          restNum: restaurantNum
        },
        product: [{
          price: {
            basePrice: basePrice
          },
          productInfo: {
            productId: productId,
            productSku: productSku,
            productName: productName
          }
        }],
        breadsticks: breadsticks,
        totalBreadCount: totalBreadCount
      });
    }
  }, {
    key: "dispatchQuickAddEvent",
    value: function dispatchQuickAddEvent(menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, productId, productName, sku, basePrice, currency, recommended, reorder, serializedCartId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "QuickAdd", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          productInfo: {
            productId: productId,
            productName: productName,
            sku: sku,
            basePrice: basePrice,
            currency: currency
          },
          recommended: recommended,
          reorder: reorder
        }]
      }));
    }
  }, {
    key: "dispatchAddToCartEvent",
    value: function dispatchAddToCartEvent(menuType, pageType, primaryCategory, subCategory1, subCategory2, subCategory3, basePrice, totalPrice, currency, addOnArray, productId, productName, productDetails, productSku, recommended, reorder, isDuplicate, breadsticks, totalBreadCount, serializedCartId, itemAddLocation) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "AddToCart", _objectSpread(_objectSpread({}, serializedCartId), {}, {
        product: [{
          category: {
            menuType: menuType,
            pageType: pageType,
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
            subCategory3: subCategory3
          },
          price: {
            basePrice: basePrice,
            totalPrice: totalPrice,
            currency: currency
          },
          addOns: {
            addOnArr: addOnArray
          },
          productInfo: {
            productId: productId,
            productName: productName,
            productDetails: productDetails,
            productSku: productSku
          },
          recommended: recommended,
          reorder: reorder,
          isDuplicate: isDuplicate
        }],
        breadsticks: breadsticks,
        totalBreadCount: totalBreadCount,
        cartAddLocation: itemAddLocation
      }));
    }
  }, {
    key: "dispatchPageViewEvent",
    value: function dispatchPageViewEvent(pageName, mobilePayType) {
      var payload = {
        pageName: pageName
      };

      if (mobilePayType) {
        payload["mobilePayType"] = mobilePayType;
      }

      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", payload);
    }
  }, {
    key: "dispatchPageViewSourceEvent",
    value: function dispatchPageViewSourceEvent(pageName, pageSource, orderId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", {
        pageName: pageName,
        pageSource: pageSource,
        orderId: orderId
      });
    }
  }, {
    key: "dispatchDisplayModalEvent",
    value: function dispatchDisplayModalEvent(modalIntent, modalContent, modalName, productId) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: modalIntent,
        modalContent: modalContent,
        modalName: modalName,
        productId: productId
      });
    }
  }, {
    key: "dispatchShowHideCartEvent",
    value: function dispatchShowHideCartEvent(showCart) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CartView", {
        showCart: showCart
      });
    }
  }, {
    key: "dispatchOrderConfirmation",
    value: function dispatchOrderConfirmation(orderId, restId, restNum, specialInstruction) {
      this.platformUtil.dispatchEvent("AnalyticsTransaction", "OrderConfirmation", {
        restId: restId,
        restNum: restNum,
        specialInstruction: specialInstruction
      });
    }
  }, {
    key: "dispatchPurchase",
    value: function dispatchPurchase() {
      this.platformUtil.dispatchEvent("AnalyticsTransaction", "Purchase", {});
    }
  }, {
    key: "dispatchOrderConfirmationAccCreat",
    value: function dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restaurantNum) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "CreateAccountComplete", {
        zipCode: zipCode,
        state: state,
        country: country,
        birthYear: birthYear,
        restId: restId,
        restNum: restaurantNum,
        hasAddress: restId ? "true" : "false"
      });
    }
  }, {
    key: "dispatchMobilePay",
    value: function dispatchMobilePay(baseCheck, discount, paymentType, tax, tip, total) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MobilePay", {
        baseCheck: baseCheck,
        discount: discount,
        paymentType: paymentType,
        tax: tax,
        tip: tip,
        total: total
      });
    }
  }, {
    key: "dispatchMobilePayComplete",
    value: function dispatchMobilePayComplete(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayComplete", payload);
    }
  }, {
    key: "dispatchMobilePayScan",
    value: function dispatchMobilePayScan(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayScan", payload);
    }
  }, {
    key: "dispatchMobilePayError",
    value: function dispatchMobilePayError(errorPayload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayError", errorPayload);
    }
  }, {
    key: "dispatchMobilePayCTAClick",
    value: function dispatchMobilePayCTAClick(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "mobilePayCTAClick", payload);
    }
  }, {
    key: "dispatchWaitlistComplete",
    value: function dispatchWaitlistComplete(waitTime, partySize, waitlist_token, restNum) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "waitlistComplete", {
        waitTime: waitTime,
        partySize: partySize,
        waitlist_token: waitlist_token,
        restNum: restNum
      });
    }
  }, {
    key: "dispatchWaitlistPartyUpdate",
    value: function dispatchWaitlistPartyUpdate(waitTime, partySize, waitlist_token) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "waitlistPartyUpdate", {
        waitTime: waitTime,
        partySize: partySize,
        waitlist_token: waitlist_token
      });
    }
  }, {
    key: "dispatchCartViewEvent",
    value: function dispatchCartViewEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CartView", payload);
    }
  }, {
    key: "dispatchCheckoutEvent",
    value: function dispatchCheckoutEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "Checkout", payload);
    }
  }, {
    key: "dispatchMenuBrowseEvent",
    value: function dispatchMenuBrowseEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "MenuBrowse", payload);
    }
  }, {
    key: "dispatchReservations",
    value: function dispatchReservations(reservationType, reservationLocation, reservationTime, reservationGuests, reservationOccasion, reservationDate, dayOfWeek, reservationPurpose) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "Reservations", {
        reservationType: reservationType,
        reservationLocation: reservationLocation,
        reservationTime: reservationTime,
        reservationGuests: reservationGuests,
        reservationOccasion: reservationOccasion,
        reservationDate: reservationDate,
        dayOfWeek: dayOfWeek,
        reservationPurpose: reservationPurpose
      });
    }
  }, {
    key: "dispatchEClubOrderConfirmation",
    value: function dispatchEClubOrderConfirmation(brands, signupChannel) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {
        brands: brands,
        signupChannel: signupChannel
      });
    }
  }, {
    key: "dispatchMenuSearchAbTestConfirmation",
    value: function dispatchMenuSearchAbTestConfirmation(isMenuSearchEnabled) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchABTest", {
        experience: isMenuSearchEnabled
      });
    }
  }, {
    key: "dispatchSearchIconClickedConfirmation",
    value: function dispatchSearchIconClickedConfirmation() {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchClicked", {});
    }
  }, {
    key: "dispatchKeywordSearchConfirmation",
    value: function dispatchKeywordSearchConfirmation(searchText, isSuggested, isMenuSearchResultsReturned) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchKeywordEvent", {
        menuSearchTerm: searchText,
        menuSearchResultsReturned: isMenuSearchResultsReturned,
        isSuggested: isSuggested
      });
    }
  }, {
    key: "dispatchSearchResultItemClickedConfirmation",
    value: function dispatchSearchResultItemClickedConfirmation(searchText, productId, productName, productPrimaryCategory, productSubCategory1, productSubCategory2) {
      this.platformUtil.dispatchEvent("AnalyticsForm", "MenuSearchResultClick", {
        menuSearchTerm: searchText,
        productId: productId,
        productName: productName,
        primaryCategory: productPrimaryCategory,
        subCategory1: productSubCategory1,
        subCategory2: productSubCategory2
      });
    }
  }, {
    key: "setWaitListData",
    value: function setWaitListData(_waitListData) {
      var _this7 = this;

      runInAction(function () {
        _this7._waitListData = _waitListData;
      });
    }
  }, {
    key: "setPageAnalyticsDetails",
    value: function setPageAnalyticsDetails(_analyticsDetails) {
      var _this8 = this;

      runInAction(function () {
        _this8._pageAnalyticsDetails = _analyticsDetails;
      });
    }
  }, {
    key: "setCurbsideTransaction",
    value: function setCurbsideTransaction(_transaction) {
      var _this9 = this;

      runInAction(function () {
        _this9._curbsideTransactionDetails = _transaction;
      });
    }
  }, {
    key: "setCurbsideAnalyticsData",
    value: function setCurbsideAnalyticsData(_data) {
      var _this10 = this;

      runInAction(function () {
        _this10._curbsideDetails = _data;
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_val) {
      var _this11 = this;

      runInAction(function () {
        _this11._appAttributes = _val;
      });
    }
  }, {
    key: "dispatchPermissionsForGeoDetect",
    value: function dispatchPermissionsForGeoDetect(pushNotificationEnabled, locationServiceStatus, restNum) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PermissionsForGeoDetect", {
        pushNotificationEnabled: pushNotificationEnabled.toString(),
        LocationServiceEnabled: locationServiceStatus,
        restNum: restNum
      });
    }
  }, {
    key: "dispatchPushNotificationEnabled",
    value: function dispatchPushNotificationEnabled() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "CurbsideCheckin", {
        pushNotificationEnabled: "true"
      });
    }
  }, {
    key: "dispatchCurbsideCheckinEvent",
    value: function dispatchCurbsideCheckinEvent(pageName, payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "PageView", _objectSpread({
        pageName: pageName
      }, payload));
    }
  }, {
    key: "dispatchCurbsideCheckinErrorEvent",
    value: function dispatchCurbsideCheckinErrorEvent(pageName, payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ErrorPage", _objectSpread({
        pageName: pageName
      }, payload));
    }
  }, {
    key: "dispatchCurbsideCTAClick",
    value: function dispatchCurbsideCTAClick(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideCheckInCTAClick", payload);
    }
  }, {
    key: "dispatchReservationStartEvent",
    value: function dispatchReservationStartEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationStart", payload);
    }
  }, {
    key: "dispatchReservationSubmitEvent",
    value: function dispatchReservationSubmitEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationSubmit", payload);
    }
  }, {
    key: "dispatchReservationCompleteEvent",
    value: function dispatchReservationCompleteEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationComplete", payload);
    }
  }, {
    key: "dispatchReservationChangeLocationEvent",
    value: function dispatchReservationChangeLocationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationChangeLocation", payload);
    }
  }, {
    key: "dispatchReservationInformationEvent",
    value: function dispatchReservationInformationEvent() {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationInformation", {});
    }
  }, {
    key: "dispatchReservationCancelEvent",
    value: function dispatchReservationCancelEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationCancel", payload);
    }
  }, {
    key: "dispatchReservationConfirmationEvent",
    value: function dispatchReservationConfirmationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationConfirmation", payload);
    }
  }, {
    key: "dispatchReservationTimeNotAvailableEvent",
    value: function dispatchReservationTimeNotAvailableEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ReservationTimeNotAvailable", payload);
    }
  }, {
    key: "dispatchEditReservationConfirmationEvent",
    value: function dispatchEditReservationConfirmationEvent(payload) {
      this.platformUtil.dispatchEvent("AnalyticsEvent", "EditReservation", payload);
    }
  }, {
    key: "dispatchPopupAppearedEvent",
    value: function dispatchPopupAppearedEvent(modalName, subTitle, restNum, additionalMessages, i18ResourceString, normalHtml, params) {
      var messages = []; // to remove html tags from text

      var regex = /(<([^>]+)>)/gi;

      if (subTitle) {
        messages.push(subTitle);
      }

      if (additionalMessages) {
        messages.push.apply(messages, _toConsumableArray(additionalMessages));
      }

      if (i18ResourceString) {
        var i18nMessage = i18next.t(i18ResourceString, _objectSpread({
          interpolation: {
            prefix: "${",
            suffix: "}"
          }
        }, params));
        messages.push(i18nMessage === null || i18nMessage === void 0 ? void 0 : i18nMessage.replace(regex, ""));
      }

      if (normalHtml) {
        messages.push(normalHtml === null || normalHtml === void 0 ? void 0 : normalHtml.replace(regex, ""));
      }

      var modalText = messages.join(", ");
      this.platformUtil.dispatchEvent("AnalyticsEvent", "ModalPageview", {
        modalName: modalName,
        modaltext: modalText,
        restNum: restNum
      });
    }
  }, {
    key: "cart",
    get: function get() {
      var cart = {};
      var sumOfBreadsticks = 0;

      try {
        var _this$_cart, _this$_cart2, _this$_cart3, _this$_cart4, _this$_cart5, _this$_cart6, _this$_cart7, _this$_cart8, _this$_cart9, _this$_cart10;

        cart = {
          attributes: {
            orderSubType: "new",
            //TODO: "new" or "reorder" //check dataLayerJSON
            orderType: (_this$_cart = this._cart) === null || _this$_cart === void 0 ? void 0 : _this$_cart.orderType,
            pickupDate: moment((_this$_cart2 = this._cart) === null || _this$_cart2 === void 0 ? void 0 : _this$_cart2.requestedPickupTime).format("MM/DD/YYYY"),
            pickupTime: moment((_this$_cart3 = this._cart) === null || _this$_cart3 === void 0 ? void 0 : _this$_cart3.requestedPickupTime).format("hh:mm A")
          },
          cartID: (_this$_cart4 = this._cart) === null || _this$_cart4 === void 0 ? void 0 : _this$_cart4.orderId,
          item: this._cart.commerceItems.map(function (item) {
            var addOnsPrice = item.subItem.map(function (addOnPrice) {
              return addOnPrice.unitPrice;
            }).reduce(function (prev, curr) {
              return prev + curr;
            }, 0);
            var basePrice = parseFloat((item.priceInfo.listPrice - addOnsPrice).toFixed(2));
            var addOnsInfo = item.subItem.map(function (addOnItem) {
              return [{
                breadCount: item.quantity * (addOnItem === null || addOnItem === void 0 ? void 0 : addOnItem.breadCount),
                nameproductName: addOnItem.displayName,
                productDescription: addOnItem.description,
                productId: addOnItem.productId,
                price: addOnItem.unitPrice
              }];
            });
            sumOfBreadsticks += (item === null || item === void 0 ? void 0 : item.quantity) * (item === null || item === void 0 ? void 0 : item.breadCount);

            if (item.subItem) {
              item.subItem.map(function (sItem) {
                var subItemBreadCount = sItem === null || sItem === void 0 ? void 0 : sItem.breadCount;
                sumOfBreadsticks += item.quantity * subItemBreadCount;
              });
            }

            return {
              breadCount: (item === null || item === void 0 ? void 0 : item.quantity) * (item === null || item === void 0 ? void 0 : item.breadCount),
              category: {
                primaryCategory: window.location.pathname.split("/")[1],
                subCategory1: window.location.pathname.split("/")[2],
                subCategory2: window.location.pathname.split("/")[3]
              },
              price: {
                basePrice: basePrice,
                currency: "USD"
              },
              productInfo: {
                productID: item.productId,
                productName: item.displayName,
                recommended: null,
                sku: item.catalogRefId,
                modifiers: addOnsInfo
              },
              quantity: item === null || item === void 0 ? void 0 : item.quantity
            };
          }),
          price: {
            basePrice: (_this$_cart5 = this._cart) === null || _this$_cart5 === void 0 ? void 0 : _this$_cart5.priceInfo.total,
            currency: (_this$_cart6 = this._cart) === null || _this$_cart6 === void 0 ? void 0 : _this$_cart6.priceInfo.currencyCode,
            voucherCode: (_this$_cart7 = this._cart) === null || _this$_cart7 === void 0 ? void 0 : _this$_cart7.couponCode,
            voucherDiscount: (_this$_cart8 = this._cart) === null || _this$_cart8 === void 0 ? void 0 : _this$_cart8.couponDiscount,
            voucherName: (_this$_cart9 = this._cart) === null || _this$_cart9 === void 0 ? void 0 : _this$_cart9.couponDescription,
            voucherType: (_this$_cart10 = this._cart) === null || _this$_cart10 === void 0 ? void 0 : _this$_cart10.discountType
          },
          totalBreadCount: sumOfBreadsticks
        };
      } catch (e) {
        cart = {};
      }

      return cart;
    }
  }, {
    key: "location",
    get: function get() {
      var location = {};

      try {
        var _this$_restaurantDeta, _this$_restaurantDeta2, _this$_restaurantDeta3, _this$_restaurantDeta4, _this$_restaurantDeta5, _this$_restaurantDeta6, _this$_appAttributes, _this$_appAttributes$, _this$_appAttributes$2;

        location = {
          locationInfo: {
            locationId: (_this$_restaurantDeta = this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.locationId,
            restaurantNum: (_this$_restaurantDeta2 = this._restaurantDetail) === null || _this$_restaurantDeta2 === void 0 ? void 0 : _this$_restaurantDeta2.restaurantNum,
            locationName: (_this$_restaurantDeta3 = this._restaurantDetail) === null || _this$_restaurantDeta3 === void 0 ? void 0 : _this$_restaurantDeta3.locationName,
            locationState: (_this$_restaurantDeta4 = this._restaurantDetail) === null || _this$_restaurantDeta4 === void 0 ? void 0 : _this$_restaurantDeta4.locationState,
            locationZip: (_this$_restaurantDeta5 = this._restaurantDetail) === null || _this$_restaurantDeta5 === void 0 ? void 0 : (_this$_restaurantDeta6 = _this$_restaurantDeta5.locationZip) === null || _this$_restaurantDeta6 === void 0 ? void 0 : _this$_restaurantDeta6.substring(0, 5),
            brandName: (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.concept) === null || _this$_appAttributes$ === void 0 ? void 0 : (_this$_appAttributes$2 = _this$_appAttributes$.conceptCodeDesc) === null || _this$_appAttributes$2 === void 0 ? void 0 : _this$_appAttributes$2.toLowerCase()
          }
        };
      } catch (e) {
        location = {};
      }

      return location;
    }
  }, {
    key: "page",
    get: function get() {
      var _this$_sessionDetails,
          _this$_sessionDetails2,
          _this12 = this;

      var page = {};
      var serverData = this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.successResponse) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.dataLayerJSON;
      var parsedData = serverData ? JSON.parse(serverData) : {};

      try {
        var _window, _window$location, _window$location$path, _parsedData$page2, _parsedData$page2$cat, _parsedData$page3, _parsedData$page3$cat, _parsedData$page4, _parsedData$page4$pag, _this$platformUtil, _parsedData$page5, _parsedData$page5$pag, _parsedData$page6, _parsedData$page6$pag, _this$platformUtil2, _parsedData$page7, _parsedData$page7$pag, _parsedData$page8, _parsedData$page8$pag, _parsedData$page9, _parsedData$page9$pag, _parsedData$page10, _parsedData$page10$pa;

        var getPageType = function getPageType() {
          var _parsedData$page, _parsedData$page$cate;

          if (_this12._pageAnalyticsDetails) {
            var _this12$_pageAnalytic;

            return (_this12$_pageAnalytic = _this12._pageAnalyticsDetails) === null || _this12$_pageAnalytic === void 0 ? void 0 : _this12$_pageAnalytic.pageType;
          } else return parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page = parsedData.page) === null || _parsedData$page === void 0 ? void 0 : (_parsedData$page$cate = _parsedData$page.category) === null || _parsedData$page$cate === void 0 ? void 0 : _parsedData$page$cate.pageType;
        };

        page = {
          category: {
            menuType: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$path = _window$location.pathname) === null || _window$location$path === void 0 ? void 0 : _window$location$path.split("/")[2],
            //TODO this does not update b/c SPA
            pageType: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page2 = parsedData.page) === null || _parsedData$page2 === void 0 ? void 0 : (_parsedData$page2$cat = _parsedData$page2.category) === null || _parsedData$page2$cat === void 0 ? void 0 : _parsedData$page2$cat.pageType,
            //TODO this does not update b/c SPA
            primaryCategory: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page3 = parsedData.page) === null || _parsedData$page3 === void 0 ? void 0 : (_parsedData$page3$cat = _parsedData$page3.category) === null || _parsedData$page3$cat === void 0 ? void 0 : _parsedData$page3$cat.primaryCategory //TODO this does not update b/c SPA

          },
          pageInfo: {
            cacheable: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page4 = parsedData.page) === null || _parsedData$page4 === void 0 ? void 0 : (_parsedData$page4$pag = _parsedData$page4.pageInfo) === null || _parsedData$page4$pag === void 0 ? void 0 : _parsedData$page4$pag.cacheable,
            destinationURL: (_this$platformUtil = this.platformUtil) === null || _this$platformUtil === void 0 ? void 0 : _this$platformUtil.getLocationPathName(),
            //TODO this does not update b/c SPA
            geoCountry: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page5 = parsedData.page) === null || _parsedData$page5 === void 0 ? void 0 : (_parsedData$page5$pag = _parsedData$page5.pageInfo) === null || _parsedData$page5$pag === void 0 ? void 0 : _parsedData$page5$pag.geoCountry,
            language: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page6 = parsedData.page) === null || _parsedData$page6 === void 0 ? void 0 : (_parsedData$page6$pag = _parsedData$page6.pageInfo) === null || _parsedData$page6$pag === void 0 ? void 0 : _parsedData$page6$pag.language,
            pageName: this._pageAnalyticsDetails ? this._pageAnalyticsDetails.pageName : (_this$platformUtil2 = this.platformUtil) === null || _this$platformUtil2 === void 0 ? void 0 : _this$platformUtil2.getLocationPathName(),
            //TODO this does not update b/c SPA
            siteBrand: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page7 = parsedData.page) === null || _parsedData$page7 === void 0 ? void 0 : (_parsedData$page7$pag = _parsedData$page7.pageInfo) === null || _parsedData$page7$pag === void 0 ? void 0 : _parsedData$page7$pag.siteBrand,
            siteName: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page8 = parsedData.page) === null || _parsedData$page8 === void 0 ? void 0 : (_parsedData$page8$pag = _parsedData$page8.pageInfo) === null || _parsedData$page8$pag === void 0 ? void 0 : _parsedData$page8$pag.siteName,
            siteType: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page9 = parsedData.page) === null || _parsedData$page9 === void 0 ? void 0 : (_parsedData$page9$pag = _parsedData$page9.pageInfo) === null || _parsedData$page9$pag === void 0 ? void 0 : _parsedData$page9$pag.siteType,
            sysEnv: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$page10 = parsedData.page) === null || _parsedData$page10 === void 0 ? void 0 : (_parsedData$page10$pa = _parsedData$page10.pageInfo) === null || _parsedData$page10$pa === void 0 ? void 0 : _parsedData$page10$pa.sysEnv,
            menuType: window.location.pathname.split("/")[2],
            //TODO this does not update b/c SPA
            pageType: getPageType(),
            //TODO this does not update b/c SPA
            primaryCategory: window.location.pathname.split("/").join("|") //TODO this does not update b/c SPA

          }
        };
      } catch (e) {
        page = {};
      }

      return page;
    }
  }, {
    key: "product",
    get: function get() {
      var _this$_sessionDetails3, _this$_sessionDetails4;

      var product = {};
      var serverData = this === null || this === void 0 ? void 0 : (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.successResponse) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.dataLayerJSON;
      var parsedData = serverData ? JSON.parse(serverData) : {};

      try {
        var _this$_menuItemDetail, _this$_menuItemDetail2, _this$_menuItemDetail3, _this$_menuItemDetail4, _this$_menuItemDetail5;

        product = {
          category: {
            menuType: window.location.pathname.split("/")[2],
            pageType: parsedData.page.category.pageType,
            primaryCategory: window.location.pathname.split("/").join("|")
          },
          price: {
            basePrice: (_this$_menuItemDetail = this._menuItemDetail) === null || _this$_menuItemDetail === void 0 ? void 0 : _this$_menuItemDetail.displayPrice.price
          },
          productInfo: {
            productId: (_this$_menuItemDetail2 = this._menuItemDetail) === null || _this$_menuItemDetail2 === void 0 ? void 0 : _this$_menuItemDetail2.id,
            productName: (_this$_menuItemDetail3 = this._menuItemDetail) === null || _this$_menuItemDetail3 === void 0 ? void 0 : _this$_menuItemDetail3.name,
            productSku: (_this$_menuItemDetail4 = this._menuItemDetail) === null || _this$_menuItemDetail4 === void 0 ? void 0 : _this$_menuItemDetail4.displayPrice.skuId,
            productDetails: (_this$_menuItemDetail5 = this._menuItemDetail) === null || _this$_menuItemDetail5 === void 0 ? void 0 : _this$_menuItemDetail5.description
          }
        };
      } catch (e) {
        product = {};
      }

      return product;
    } // get it from dataLayerJSON profile key

  }, {
    key: "user",
    get: function get() {
      var _this$_sessionDetails5, _this$_sessionDetails6;

      var user = {};
      var serverData = this === null || this === void 0 ? void 0 : (_this$_sessionDetails5 = this._sessionDetails) === null || _this$_sessionDetails5 === void 0 ? void 0 : (_this$_sessionDetails6 = _this$_sessionDetails5.successResponse) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.dataLayerJSON;

      try {
        var parsedData = serverData ? JSON.parse(serverData) : {};
        user = parsedData.user;
      } catch (e) {
        user = {};
      }

      return user;
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      var _this$_sessionDetails7, _this$_sessionDetails8, _this$_sessionDetails9;

      return this._sessionDetails ? !((_this$_sessionDetails7 = this._sessionDetails) !== null && _this$_sessionDetails7 !== void 0 && (_this$_sessionDetails8 = _this$_sessionDetails7.successResponse) !== null && _this$_sessionDetails8 !== void 0 && (_this$_sessionDetails9 = _this$_sessionDetails8.profile) !== null && _this$_sessionDetails9 !== void 0 && _this$_sessionDetails9["transient"]) : false;
    }
    /**
     * Return dataLayerJSON from session Details if available.
     * Else construct the dataLayerJSON with local data available for modules like curbside.
     * sessionDetails is set in UserStore
     * restaurantDetails needs to come from respective modules.
     */

  }, {
    key: "dataLayerJSON",
    get: function get() {
      var _this$_sessionDetails10, _this$_sessionDetails11, _this$platformUtil3;

      var serverData = this === null || this === void 0 ? void 0 : (_this$_sessionDetails10 = this._sessionDetails) === null || _this$_sessionDetails10 === void 0 ? void 0 : (_this$_sessionDetails11 = _this$_sessionDetails10.successResponse) === null || _this$_sessionDetails11 === void 0 ? void 0 : _this$_sessionDetails11.dataLayerJSON;
      var platform = (_this$platformUtil3 = this.platformUtil) === null || _this$platformUtil3 === void 0 ? void 0 : _this$platformUtil3.PLATFORM_TYPE;
      var platformIsMobileApp = platform === PlatformType.APP ? true : false;

      if (serverData && (!this._restaurantDetail || platformIsMobileApp)) {
        var data = JSON.parse(serverData);

        if (this._changeErrorPageNameWithoutRD) {
          var _data$page, _this$_pageAnalyticsD, _this$_pageAnalyticsD2;

          data.page = _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.page), {}, {
            pageInfo: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : (_data$page = data.page) === null || _data$page === void 0 ? void 0 : _data$page.pageInfo), {}, {
              pageName: this === null || this === void 0 ? void 0 : (_this$_pageAnalyticsD = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD === void 0 ? void 0 : _this$_pageAnalyticsD.pageName,
              pageTitle: this === null || this === void 0 ? void 0 : (_this$_pageAnalyticsD2 = this._pageAnalyticsDetails) === null || _this$_pageAnalyticsD2 === void 0 ? void 0 : _this$_pageAnalyticsD2.pageType
            })
          });
        }

        return data;
      } else {
        if (this._returnWindowDigData) {
          var _data2 = window.digitalData;

          if (this._restaurantDetail) {
            _data2.location = this.location;
          }

          return _data2;
        } //if restaurantDetail is injected to the model, localData is used


        return {
          location: this.location,
          cart: this.cart,
          page: this.page,
          product: this.product,
          user: this.user,
          event: [],
          waitList: this._waitListData ? toJS(this._waitListData) : {},
          transaction: this._curbsideTransactionDetails ? toJS(this._curbsideTransactionDetails) : {},
          curbside: this._curbsideDetails ? toJS(this._curbsideDetails) : {}
        };
      }
    }
  }]);

  return AnalyticsModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_cart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_menuItemDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_returnWindowDigData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_waitListData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_pageAnalyticsDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_curbsideTransactionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_curbsideDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_changeErrorPageNameWithoutRD", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "cart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "location", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "location"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "page", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "page"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "product", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "user", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataLayerJSON", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataLayerJSON"), _class.prototype)), _class);
export { AnalyticsModel as default };